var _title, _desc, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgContactles = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "21px",
    viewBox: "0 0 29 21",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "bekontakte")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uzsakymai",
    transform: "translate(-1147.000000, -175.000000)",
    fill: "#464648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bekontakte",
    transform: "translate(1147.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.481676,1.90105263 L15.08,1.90105263 L6.51832403,1.90105263 C6.4289501,1.90105263 6.34240809,1.86970043 6.27377213,1.81245705 L4.36884306,0.223718601 C4.21699184,0.0970724807 3.99357498,0.107311567 3.85394423,0.247316164 L0.275849708,3.83499068 C0.126939912,3.98429917 0.127263115,4.22605285 0.276571602,4.37496265 C0.27862824,4.37701379 0.280708217,4.3790414 0.282811126,4.38104508 L2.20156733,6.20926107 C2.27719792,6.28132288 2.32,6.38122565 2.32,6.48569044 L2.32,20.6905263 L4.06,20.6905263 L4.06,5.42664401 C4.06,5.29598866 3.99319217,5.17440519 3.88290564,5.10435022 L2.72353215,4.36790608 C2.54553421,4.25484024 2.49289634,4.01888642 2.60596218,3.84088848 C2.6211905,3.81691475 2.63904617,3.79471499 2.65919782,3.77470117 L3.81924373,2.62258974 C3.96886381,2.47399303 4.21061629,2.47482264 4.359213,2.62444272 C4.3626052,2.62785828 4.3659325,2.63133769 4.36919312,2.63487907 L5.10657079,3.43575098 C5.17886636,3.51427178 5.28072796,3.55894737 5.38746204,3.55894737 L15.08,3.55894737 L23.612538,3.55894737 C23.719272,3.55894737 23.8211336,3.51427178 23.8934292,3.43575098 L24.6308069,2.63487907 C24.7736398,2.47974712 25.015188,2.46977675 25.1703199,2.61260963 C25.1738613,2.61587025 25.1773407,2.61919755 25.1807563,2.62258974 L26.3408022,3.77470117 C26.4904223,3.92329789 26.4912519,4.16505036 26.3426552,4.31467045 C26.3226413,4.33482209 26.3004416,4.35267776 26.2764679,4.36790608 L25.1170944,5.10435022 C25.0068078,5.17440519 24.94,5.29598866 24.94,5.42664401 L24.94,20.6905263 L26.68,20.6905263 L26.68,6.48569044 C26.68,6.38122565 26.7228021,6.28132288 26.7984327,6.20926107 L28.7171889,4.38104508 C28.8698566,4.23558128 28.8756965,3.99389793 28.7302327,3.8412302 C28.728229,3.83912729 28.7262014,3.83704732 28.7241503,3.83499068 L25.1460558,0.247316164 C25.006425,0.107311567 24.7830082,0.0970724807 24.6311569,0.223718601 L22.7262279,1.81245705 C22.6575919,1.86970043 22.5710499,1.90105263 22.481676,1.90105263 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 13.5625581,
    cy: 7.15105263,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 13.5625581,
    cy: 9.36157895,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4996203,13.8817122 L17.6203797,10.9203931 C17.5503411,10.8100259 17.4287111,10.7431579 17.2979965,10.7431579 L10.3531663,10.7431579 C10.2224517,10.7431579 10.1008217,10.8100259 10.0307831,10.9203931 L8.15154246,13.8817122 C8.08150392,13.9920794 7.95987388,14.0589474 7.82915928,14.0589474 L7.77604651,14.0589474 C7.65582886,14.0589474 7.5583732,14.156403 7.5583732,14.2766207 C7.5583732,14.2902809 7.55965907,14.3039107 7.56221379,14.3173299 L8.51592574,19.3268806 C8.54446639,19.4767958 8.67553183,19.5852632 8.82813953,19.5852632 C8.97340327,19.5852632 9.09116279,19.7030227 9.09116279,19.8482864 L9.09116279,20.3087081 C9.09116279,20.5195805 9.26210861,20.6905263 9.47298097,20.6905263 L10.8135307,20.6905263 C11.024403,20.6905263 11.1953488,20.5195805 11.1953488,20.3087081 L11.1953488,19.9670813 C11.1953488,19.756209 11.3662947,19.5852632 11.577167,19.5852632 L16.0739958,19.5852632 C16.2848681,19.5852632 16.455814,19.756209 16.455814,19.9670813 L16.455814,20.3087081 C16.455814,20.5195805 16.6267598,20.6905263 16.8376321,20.6905263 L18.1781818,20.6905263 C18.3890542,20.6905263 18.56,20.5195805 18.56,20.3087081 L18.56,19.8482864 C18.56,19.7030227 18.6777595,19.5852632 18.8230233,19.5852632 C18.975631,19.5852632 19.1066964,19.4767958 19.135237,19.3268806 L20.088949,14.3173299 C20.1114321,14.1992333 20.033922,14.085271 19.9158255,14.062788 C19.9024063,14.0602332 19.8887765,14.0589474 19.8751163,14.0589474 L19.8220035,14.0589474 C19.6912889,14.0589474 19.5696589,13.9920794 19.4996203,13.8817122 Z M10.1432558,17.9273684 C9.56220088,17.9273684 9.09116279,17.4325252 9.09116279,16.8221053 C9.09116279,16.2116853 9.56220088,15.7168421 10.1432558,15.7168421 C10.7243107,15.7168421 11.1953488,16.2116853 11.1953488,16.8221053 C11.1953488,17.4325252 10.7243107,17.9273684 10.1432558,17.9273684 Z M17.507907,17.9273684 C16.926852,17.9273684 16.455814,17.4325252 16.455814,16.8221053 C16.455814,16.2116853 16.926852,15.7168421 17.507907,15.7168421 C18.0889619,15.7168421 18.56,16.2116853 18.56,16.8221053 C18.56,17.4325252 18.0889619,17.9273684 17.507907,17.9273684 Z M9.09116279,14.6115789 L10.6693023,11.8484211 L16.9818605,11.8484211 L18.56,14.6115789 L9.09116279,14.6115789 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 11.4583721,
    cy: 7.15105263,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 10.9323256,
    cy: 9.36157895,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 9.35418605,
    cy: 7.15105263,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 8.30209302,
    cy: 9.36157895,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 7.25,
    cy: 11.5721053,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 15.6667442,
    cy: 7.15105263,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 17.7709302,
    cy: 7.15105263,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 16.1927907,
    cy: 9.36157895,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 18.8230233,
    cy: 9.36157895,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 20.4011628,
    cy: 11.5721053,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 21.1902326,
    y: 9.63789474,
    width: 1.05209302,
    height: 11.0526316
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2317881,4.35753238 L22.2423256,9.63789474 L21.1902326,9.63789474 L19.0860465,4.11157895 L19.8749606,4.11157895 C20.0334158,4.11157895 20.175404,4.20944831 20.2317881,4.35753238 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42088795,4.11157895 L19.7563214,4.11157895 C19.9671937,4.11157895 20.1381395,4.28252477 20.1381395,4.49339713 L20.1381395,5.21684211 L8.42088795,5.21684211 C8.21001559,5.21684211 8.03906977,5.04589628 8.03906977,4.83502392 L8.03906977,4.49339713 C8.03906977,4.28252477 8.21001559,4.11157895 8.42088795,4.11157895 Z",
    id: "Rectangle",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contactles.f5a9809c.svg";
export { ForwardRef as ReactComponent };